import React, { useContext, useEffect, useState } from 'react';
import BoxShadow from '../../atoms/BoxShadow';
import { Comparisons, Comparison as StyledComparison, Link, } from './components';
import { purify } from '../../utils/helpers';
import DeviceContext from '../../configuration/context/device';
import EmbeddedContext from '../../configuration/context/embedded';
function AdditionalComparisons({ data }) {
    const { isEmbedded } = useContext(EmbeddedContext);
    const device = useContext(DeviceContext);
    const [isMobile, setIsMobile] = useState(device.platform === 'ios');
    useEffect(() => {
        if (device.platform === 'ios') {
            setIsMobile(true);
        }
    }, [device]);
    if (!data) {
        return null;
    }
    return (React.createElement(BoxShadow, null,
        React.createElement(Comparisons, null, data.map(({ headline, cta }, i) => (React.createElement(StyledComparison, { key: `additional-${i}` },
            React.createElement("span", { dangerouslySetInnerHTML: { __html: purify(headline) } }),
            cta && (!isMobile || !isEmbedded) && React.createElement(Link, Object.assign({ standalone: true }, cta))))))));
}
export default AdditionalComparisons;
//# sourceMappingURL=additional-comparisons.js.map